import React from 'react';
import Lite_InjectScriptForm from './Lite_InjectScriptForm';
import styles from './Lite_InjectScriptFormCont.module.css';

const Lite_InjectScriptFormCont = () => (
  <div className={styles['signup-container']}>
    <header className={styles.header}>
      <h3 className={styles['email-header']}>Inject Script</h3>
    </header>
    <section>
      <Lite_InjectScriptForm />
    </section>
  </div>
);

export default Lite_InjectScriptFormCont;
